<template>
    <div id="bankSummary" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ReceiptHeader" >Bank Summary</span>
                    <!-- <button type="submit" class="btn btn-secondary pull-right " v-on:click.prevent="BackReceiptList" >
                        <i class="fp-back"> </i> Back
                    </button> -->
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="ReceiptForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <!-- <div class="col form-group">
                                        <label class="control-label require">Period Month</label>
                                        <v-select v-model="processed_date" name="processed_date" placeholder="Select Date."
                                                label="text"
                                                :options="dateArr">
                                        </v-select>
                                        <div class="field-error">{{processed_date_error_msg}}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="processed_date">Period Month:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="processed_date" name="processed_date" v-model="processed_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="processed_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{processed_date_error_msg}}</div>
                                    </div>

                                    <div class="col-md-2">
                                        <button type="submit" v-on:click.prevent="fetchBankSummary()" class="btn btn-primary mt-4">
                                            <!-- <i class="fp-add"></i>  --> Summary
                                        </button>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-md-4 offset-md-8" style="float: left !important;margin-left: 0;margin-top: 50px;">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td class="bg-gray"> Opening Balance: </td>
                                                    <td class="text-right"> {{bankArr.opening}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-gray"> Deposit: </td>
                                                    <td class="text-right"> {{bankArr.deposit}} </td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-gray"> Withdraw: </td>
                                                    <td class="text-right"> -{{bankArr.withdraw}} </td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-gray"> Closing Balance: </td>
                                                    <td class="text-right"> {{bankArr.closing}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import moment from 'moment'


export default {
  name: "ReceiptCreate",
  
  metaInfo() {
      return {title: "Bank Summary | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading:false,
    dateArr:[],
    processed_date:'',
    processed_date_error_msg:'',
    // deposit:0,
    // withdraw:0,
    // opening_balance:0,
    // closing:0,
    optionsDate: {
        format: 'MM/YYYY',
        useCurrent: true,
    },
    bankArr:{
        deposit: '$0.00',
        withdraw:'$0.00',
        opening:'$0.00',
        closing:'$0.00',
    }
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_payment_receipt') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
  },
  methods: {
    // getLastDateofmonth:function(){
    //     var self = this;
    //     var date = new Date();
    //     var arr = [];
    //     for(var i = 3; i >= 0;i--){
    //         var momentDate = moment(date).subtract(i, 'months').format('MM/DD/YYYY');
    //         arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));
    //     }
    //     self.dateArr = arr;
    // },
   
    fetchBankSummary: function(){
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/bank-summary",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                pr_date:self.processed_date
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.bankArr = data.content;
                }else{
                    self.bankArr = {
                        deposit: '$0.00',
                        withdraw:'$0.00',
                        opening:'$0.00',
                        closing:'$0.00',
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });
    },
  }
};
</script>
<style scoped>
.right-adjust{
    width: 50%!important;
    float: right;
    height: 38px;
    padding-right: 8px;
    border-bottom: 1px solid !important;
    border-bottom-color: #8080802e !important;
}
.overClass{
    overflow: visible !important;
}

.currencyinput input {
    border: 0;
}

</style>




// WEBPACK FOOTER //
// src/components/BankSummary.vue